<template>
  <layout :title="pageTitle">
    <form @submit.prevent="submit">
      <section class="section">
        <div class="columns">
          <div class="column is-12">
            <div class="box">
              <a id="overview"></a>
              <h3>Overview</h3>
              <hr style="margin-top: 15px" />
              <div class="columns">
                <div class="column">
                  <b-field
                    label="Project Name"
                    :type="{ 'is-danger': errors?.name }"
                    :message="errors?.name"
                  >
                    <b-input v-model="form.name"></b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field
                    label="Start Date"
                    :type="{ 'is-danger': errors?.start_date }"
                    :message="errors?.start_date"
                  >
                    <b-datepicker
                      v-model="form.start_date"
                      placeholder="Select a start date"
                      trap-focus
                    >
                    </b-datepicker>
                  </b-field>
                </div>
                <div class="column">
                  <b-field
                    label="Initial End Date"
                    :type="{ 'is-danger': errors?.soft_end_date }"
                    :message="errors?.soft_end_date"
                  >
                    <b-datepicker
                      v-model="form.soft_end_date"
                      :min-date="form.start_date"
                      placeholder="Select an initial end date"
                      trap-focus
                    >
                    </b-datepicker>
                  </b-field>
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <b-field
                    label="Final End Date"
                    :type="{ 'is-danger': errors?.end_date }"
                    :message="errors?.end_date"
                  >
                    <b-datepicker
                      v-model="form.end_date"
                      :min-date="form.start_date"
                      placeholder="Select a final end date"
                      trap-focus
                    >
                    </b-datepicker>
                  </b-field>
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <label class="label"> Client </label>
                  <b-field>
                    <b-select
                      placeholder="Select a client"
                      expanded
                      v-model="form.client"
                    >
                      <option
                        v-for="client in clients"
                        :value="client"
                        :key="client.unique_id"
                      >
                        {{ client.name }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
              </div>

              <div class="columns" v-if="form.client">
                <div class="column">
                  <b-field
                    label="Project Group"
                    :type="{ 'is-danger': errors?.project_group }"
                    :message="errors?.project_group"
                  >
                    <b-select
                      v-if="
                        form.client.project_groups &&
                        form.client.project_groups.length > 0
                      "
                      placeholder="Select a project group"
                      expanded
                      v-model="form.project_group"
                      @input="
                        form.question_set = form.project_group.question_set
                      "
                    >
                      <option
                        v-for="project_group in form.client.project_groups"
                        :value="project_group"
                        :key="project_group.id"
                      >
                        {{ project_group.name }}
                      </option>
                    </b-select>
                    <p v-else>No project groups available</p>
                  </b-field>
                </div>
              </div>

              <div class="columns" v-if="form.project_group">
                <div class="column">
                  <label class="label"> Question Set </label>
                  <b-field>
                    <b-input
                      v-if="form.project_group"
                      disabled
                      :value="form.project_group.question_set.name"
                    ></b-input>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <button
              type="submit"
              class="button is-primary"
              :disabled="isDisabled"
            >
              Next
            </button>
          </div>
        </div>
      </section>
    </form>
  </layout>
</template>

<script>
import Layout from '../Layout';

export default {
  components: {
    Layout,
  },
  props: {
    project: { type: Object },
    clients: { type: Array },
  },
  remember: 'form',
  data() {
    return {
      pageTitle: 'Add Project',
      showClientModel: false,
      showQuestionSetModal: false,
      form: {
        ...this.project,
      },
    };
  },
  computed: {
    errors() {
      return this.$page.props.errors;
    },
    isDisabled: function () {
      return (
        this.form.processing ||
        !this.form.name ||
        !this.form.start_date ||
        !this.form.end_date ||
        !this.form.client ||
        !this.form.project_group
      );
    },
  },
  methods: {
    submit: function () {
      this.$inertia.post(route('projects.store'), this.form);
    },
  },
  watch: {
    'form.client'(newClient, oldClient) {
      if (newClient !== oldClient) {
        this.form.project_group = newClient.project_groups[0] ?? null;
      }
    },
    'form.project_group'(newGroup, oldGroup) {
      if (newGroup !== oldGroup) {
        this.form.question_set = newGroup.question_set ?? null;
      }
    },
  },
};
</script>
